import { useDispatch } from "react-redux";

import { useMount } from "app/custom-hooks/useMount";

import { getSalesforceStatusThunk } from "../../store/effects/salesforce/status";

const useSalesforceStatusCall = (): void => {
    const dispatch = useDispatch();

    useMount(() => {
        void dispatch(getSalesforceStatusThunk());
    });
};

export default useSalesforceStatusCall;
